import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ActivityOption {
  id: number;
  name: string;
}

export interface ProjectOption {
  id: number;
  name: string;
  activities: ActivityOption[];
}

export interface CustomerOption {
  id: number;
  name: string;
  projects: ProjectOption[];
}

@Injectable({
  providedIn: 'root',
})
export class CustomerProjectsService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getCustomerProjects(): Observable<CustomerOption[]> {
    return this.http.get<CustomerOption[]>('/api/customerprojects');
  }
}
